import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useSignal } from '@preact/signals';
import { useTranslation } from 'react-i18next';
import '@etchteam/diamond-ui/control/Input/Input';
import '@etchteam/diamond-ui/control/Button/Button';
import '@etchteam/diamond-ui/composition/Collapse/Collapse';
import '@/components/content/Icon/Icon';
import useAnalytics from '@/lib/useAnalytics';
export default function RateThisInfo() {
    const { t } = useTranslation();
    const tContext = 'components.rateThisInfo';
    const rating = useSignal(undefined);
    const hasSubmittedFeedback = useSignal(false);
    const comment = useSignal('');
    const commentValid = useSignal(true);
    const commentOpen = !!rating.value && !hasSubmittedFeedback.value;
    const { recordEvent } = useAnalytics();
    function handleRatingChange(value) {
        rating.value = value;
        recordEvent({
            category: 'Rating',
            action: value,
        });
    }
    function handleSubmit(event) {
        event.preventDefault();
        if (comment.value.length === 0 || comment.value.length > 250) {
            commentValid.value = false;
            return;
        }
        recordEvent({
            category: 'Rating::Feedback',
            action: `Rating: ${rating.value}, Comment: ${comment.value}`,
        });
        hasSubmittedFeedback.value = true;
    }
    function handleCommentBlur(value) {
        comment.value = value;
        commentValid.value = Boolean(value) && value.length <= 250;
    }
    function handleCommentInput(value) {
        comment.value = value;
        if (value && value.length <= 250) {
            commentValid.value = true;
        }
    }
    return (_jsx("locator-rate-this-info", { children: _jsxs("form", { onSubmit: handleSubmit, children: [_jsxs("fieldset", { children: [_jsx("legend", { children: _jsx("h2", { children: hasSubmittedFeedback.value
                                    ? t(`${tContext}.result.${rating.value}`)
                                    : t(`${tContext}.title`) }) }), _jsxs("div", { className: "locator-rate-this-info__rating", children: [_jsxs("label", { children: [_jsx("input", { type: "radio", id: "rating-thumb-up", name: "rating", value: "1", disabled: hasSubmittedFeedback.value, onChange: () => handleRatingChange('positive') }), _jsx("locator-icon", { icon: "thumb-up", label: t(`${tContext}.thumbUp`) })] }), _jsxs("label", { children: [_jsx("input", { type: "radio", id: "rating-thumb-down", name: "rating", value: "-1", disabled: hasSubmittedFeedback.value, onChange: () => handleRatingChange('negative') }), _jsx("locator-icon", { icon: "thumb-down", label: t(`${tContext}.thumbDown`) })] })] })] }), !rating.value && (_jsx("p", { className: "text-color-muted diamond-text-size-sm", children: t(`${tContext}.help`) })), _jsxs("diamond-collapse", { open: !!rating.value && !hasSubmittedFeedback.value, children: [_jsxs("diamond-form-group", { className: "locator-rate-this-info__comment diamond-spacing-bottom-md", children: [_jsx("label", { htmlFor: "rating-comment", children: t(`${tContext}.comment.label`) }), _jsxs("diamond-input", { state: commentValid.value ? undefined : 'invalid', children: [_jsx("textarea", { id: "rating-comment", name: "comment", placeholder: t(`${tContext}.comment.placeholder`), onBlur: (event) => handleCommentBlur(event.currentTarget?.value), onInput: (event) => handleCommentInput(event.currentTarget?.value), disabled: !commentOpen, "aria-invalid": !commentValid.value, "aria-errormessage": !commentValid.value ? 'rating-comment-error' : undefined }), _jsxs("span", { className: comment.value.length > 250
                                                ? 'text-color-negative'
                                                : 'text-color-muted', children: [comment.value.length, " / 250"] })] }), !commentValid.value && (_jsx("p", { id: "rating-comment-error", className: "text-color-negative diamond-text-size-sm diamond-spacing-top-xs", "aria-live": "polite", children: t(`${tContext}.comment.error`) }))] }), _jsx("diamond-button", { width: "full-width", children: _jsx("button", { type: "submit", children: t(`${tContext}.cta`) }) })] }), _jsx("output", { name: "result", className: "text-color-positive diamond-text-size-sm", htmlFor: "rating-thumb-up rating-thumb-down rating-comment", children: hasSubmittedFeedback.value
                        ? t(`${tContext}.result.confirmation`)
                        : '' })] }) }));
}
